import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nav-layout',
  templateUrl: './nav-layout.component.html',
})
export class NavLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
